export const formatTimeWithoutMilliseconds = (time: string): string =>
  new Date(time).toLocaleString("en-US", {dateStyle: "long", timeStyle: "short"});
